export function reloadWithPostData(data: Record<string, string>, newTab = false) {
    const form = document.createElement("form");
    form.setAttribute("style", "display: none;");
    form.setAttribute("action", location.pathname);
    form.setAttribute("method", "POST");
    if (newTab) {
        form.setAttribute("target", "_blank");
    }

    for (const key in data) {
        const inp = document.createElement("input");
        inp.setAttribute("type", "hidden");
        inp.setAttribute("name", key);
        inp.setAttribute("value", data[key]);
        form.appendChild(inp);
    }

    document.body.appendChild(form);
    form.submit();
}
